import React, { useState, useEffect } from 'react';
import { Clock, Mail, ChevronRight } from 'lucide-react';
import api from '../../services/api';

// Staff surfacing of PROPOSED appointment requests — used in the calendar side
// panel (no caseId) and the case Communication tab (caseId). On accept the request
// leaves 'proposed', so it drops from this list and the appointment appears in the
// normal calendar/case surfaces.
export default function PendingRequestsPanel({ caseId = null, reloadKey = 0, compact = false }) {
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const params = { state: 'proposed' };
    if (caseId) params.case_id = caseId;
    api.get('/appointments/requests', { params })
      .then((r) => { if (!cancelled) setRows(r.data?.requests || []); })
      .catch(() => { if (!cancelled) setRows([]); })
      .finally(() => { if (!cancelled) setLoaded(true); });
    return () => { cancelled = true; };
  }, [caseId, reloadKey]);

  if (loaded && rows.length === 0) return null;

  return (
    <div className={`mb-4 rounded-xl border border-virgo-gold-500/30 bg-virgo-gold-500/5 ${compact ? 'p-3' : 'p-4'}`}>
      <div className="flex items-center gap-2 text-virgo-gold-300 text-sm font-medium mb-2">
        <Clock size={15} /> Pending appointment requests {rows.length > 0 && <span className="text-virgo-gold-400/70">({rows.length})</span>}
      </div>
      <div className="space-y-1.5 max-h-72 overflow-y-auto pr-1">
        {/* B3: queues sort OLDEST-first — age is debt. */}
        {[...rows].sort((a, b) => new Date(a.created_at || 0) - new Date(b.created_at || 0)).map((r) => (
          <div key={r.id} className="flex items-center justify-between text-sm bg-virgo-navy-900/60 rounded-lg px-3 py-2">
            <div className="min-w-0">
              <div className="text-virgo-teal-100 truncate">{r.recipient_name || r.recipient_email}</div>
              <div className="text-[11px] text-virgo-teal-500 flex items-center gap-2">
                <Mail size={11} /> {r.recipient_email}
                <span>· sent {r.created_at ? new Date(r.created_at).toLocaleDateString([], { month: 'short', day: 'numeric' }) : ''}</span>
                {r.expires_at && <span>· expires {new Date(r.expires_at).toLocaleDateString([], { month: 'short', day: 'numeric' })}</span>}
              </div>
            </div>
            <span className="text-[10px] px-2 py-0.5 rounded bg-virgo-gold-500/20 text-virgo-gold-200 whitespace-nowrap">{r.open_availability ? 'availability sent' : 'times proposed'}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
